import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[application-form]',
    standalone: false
})
export class ApplicationFormDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}